module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-popup"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Popup")]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("基础用法")]), _vm._v(" "), _c('div', {
    staticClass: "zan-button-1"
  }, [_c('zan-button', {
    on: {
      "click": function($event) {
        _vm.popupShow1 = true
      }
    }
  }, [_vm._v("从下方弹出popup")])], 1), _vm._v(" "), _c('zan-popup', {
    staticClass: "zan-popup-1",
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.popupShow1),
      callback: function($$v) {
        _vm.popupShow1 = $$v
      }
    }
  }, [_vm._v("\n    xxxx\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "zan-button-1"
  }, [_c('zan-button', {
    on: {
      "click": function($event) {
        _vm.popupShow2 = true
      }
    }
  }, [_vm._v("从上方方弹出popup")])], 1), _vm._v(" "), _c('zan-popup', {
    staticClass: "zan-popup-2",
    attrs: {
      "position": "top",
      "overlay": false
    },
    model: {
      value: (_vm.popupShow2),
      callback: function($$v) {
        _vm.popupShow2 = $$v
      }
    }
  }, [_vm._v("\n    更新成功\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "zan-button-1"
  }, [_c('zan-button', {
    on: {
      "click": function($event) {
        _vm.popupShow3 = true
      }
    }
  }, [_vm._v("从右方弹出popup")])], 1), _vm._v(" "), _c('zan-popup', {
    staticClass: "zan-popup-3",
    attrs: {
      "position": "right",
      "overlay": false
    },
    model: {
      value: (_vm.popupShow3),
      callback: function($$v) {
        _vm.popupShow3 = $$v
      }
    }
  }, [_c('zan-button', {
    nativeOn: {
      "click": function($event) {
        _vm.popupShow3 = false
      }
    }
  }, [_vm._v("关闭 popup")])], 1), _vm._v(" "), _c('div', {
    staticClass: "zan-button-1"
  }, [_c('zan-button', {
    on: {
      "click": function($event) {
        _vm.popupShow4 = true
      }
    }
  }, [_vm._v("从中间弹出popup")])], 1), _vm._v(" "), _c('zan-popup', {
    staticClass: "zan-popup-4",
    attrs: {
      "transition": "popup-fade"
    },
    model: {
      value: (_vm.popupShow4),
      callback: function($$v) {
        _vm.popupShow4 = $$v
      }
    }
  }, [_vm._v("\n    一些内容\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-703eae7e!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/examples/popup.vue
// module id = 251
// module chunks = 0